import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { IMfaSessionDetails } from 'src/apps/mfa/services/MfaDashboardServiceTypes';
import { getMfaSessionDetails } from 'src/apps/mfa/services/MfaSingleSessionService';
import { MFA_SESSION_DETAILS } from 'src/common/providers/reactQueryProvider/QueryKeys';

export const useMfaSessionDetailsQuery = (
	sessionId: string
): UseQueryResult<IMfaSessionDetails> => {
	const sessionDetailsQuery = useQuery([MFA_SESSION_DETAILS, sessionId], () =>
		getMfaSessionDetails(sessionId)
	);

	return sessionDetailsQuery;
};
